import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';

@Component({
	selector: 'app-device-donut',
	styleUrls: ['./device-donut.component.css'],
	templateUrl: './device-donut.component.html'
})
export class DeviceDonutComponent implements OnInit, AfterViewInit, WidgetCore, OnDestroy {
	@ViewChild('chartElement') chartElement: ElementRef;

	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() colors: string;
	@Input() groupby: string;
	public seriesData: any[] = [];

	public showLoad = true;
	public hasData = true;
	public donutColors: string[] = [];
	public colorPalette: ColorPalette;
	public chartObj: any;
	public reloadSubscription;
	public widgetDataSubscription;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {}

	ngAfterViewInit(): void {
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.donutColors = this.colors.split(',');
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.chartObj) {
			this.chartObj.destroy();
		}
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.showLoad = true;
		this.hasData = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
			}
		});
	}

	processResponseData(responseData: any): void {
		const chartData: any[] = [];
		this.hasData = responseData.length > 0;
		for (let i = 0; i < responseData.length; i++) {
			const chartObj: any = {};
			chartObj.name = responseData[i].device;
			chartObj.color = this.colorUtilityService.getHEXByColorType(this.colorPalette, this.donutColors[i], 1);
			chartObj.y = responseData[i][this.groupby] * 1;
			chartData.push(chartObj);
		}
		this.seriesData = chartData;
	}
}
